module.exports = __webpack_public_path__ + "static/img/note.8e4f9957.svg";